import { render, staticRenderFns } from "./ExchangeRateSetEdit.vue?vue&type=template&id=2f2a0b10"
import script from "./ExchangeRateSetEdit.vue?vue&type=script&lang=js"
export * from "./ExchangeRateSetEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports